import React, { createContext, useContext, useState, useCallback } from "react";
import ApplyLoanModal from "../components/Global/apply-loan-modal";
import SuccessModal from "../components/Global/success-modal";

const LoanModalContext = createContext(null);

export function LoanModalProvider({ children }) {
  const [isApplyOpen, setIsApplyOpen] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [loanType, setLoanType] = useState("Personal Loan");
  const [submittedData, setSubmittedData] = useState(null);

  const openLoanModal = useCallback((type = "Personal Loan") => {
    setLoanType(type);
    setIsApplyOpen(true);
    setIsSuccessOpen(false);
  }, []);

  const closeLoanModal = useCallback(() => {
    setIsApplyOpen(false);
  }, []);

  const handleApplySuccess = useCallback((formData) => {
    setSubmittedData(formData);
    setIsApplyOpen(false);
    setIsSuccessOpen(true);
  }, []);

  const closeSuccessModal = useCallback(() => {
    setIsSuccessOpen(false);
  }, []);

  return (
    <LoanModalContext.Provider
      value={{
        isOpen: isApplyOpen,
        loanType,
        openLoanModal,
        closeLoanModal,
        closeSuccessModal,
      }}
    >
      {children}

      {/* 1. Loan Application Modal */}
      <ApplyLoanModal
        isOpen={isApplyOpen}
        onClose={closeLoanModal}
        onSuccess={handleApplySuccess}
        defaultLoanType={loanType}
      />

      {/* 2. Success Confirmation Modal */}
      <SuccessModal
        isOpen={isSuccessOpen}
        onClose={closeSuccessModal}
        data={submittedData}
      />
    </LoanModalContext.Provider>
  );
}

export function useLoanModal() {
  const context = useContext(LoanModalContext);
  if (!context) {
    throw new Error("useLoanModal must be used within a LoanModalProvider");
  }
  return context;
}
